import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { home } from "@paths";
import { useEstimateEditorStore } from "@tools";
import { Alert } from "@components";
import { Check, Close } from "@material-ui/icons";
import { Grid } from "@material-ui/core";

export const EstimateAlerts = observer(() => {
  const {t} = useTranslation();
  const editorStore = useEstimateEditorStore();
  const navigate = useNavigate();
  
  const {
    isRemoved,
    isRestored,
    aiGenerationSuccessAlert,
    aiGenerationFileStatus,
  } = editorStore;
  
  return <>
    {
      isRemoved &&
      <Alert
        isOpen
        title={t("alerts.editor.project_removed")}
        acceptText={t("alerts.editor.close_editor")}
        onAccept={() => navigate(home)}
      />
    }
    {
      isRestored &&
      <Alert
        isOpen
        title={t("alerts.editor.project_restored")}
        acceptText={t("common.close")}
        onAccept={() => editorStore.setRestored()}
      />
    }
    {
      aiGenerationSuccessAlert && (
        aiGenerationFileStatus?.length
          ? <Alert
            isOpen
            title={t("alerts.editor.ai.success.title")}
            acceptText={t("common.close")}
            onAccept={() => editorStore.setAiGenerationSuccessAlert(false)}
            width={420}
          >
            <p className="mb-2">
              { t("alerts.editor.ai.success.file_subtitle") }
            </p>
            {
              aiGenerationFileStatus?.map(({ name, url, success }) => (
                <Grid item container wrap="nowrap" className="my-1" key={url}>
                  <strong className="text-nowrap">{name}</strong>
                  <span className="mx-1">{" - "}</span>
                  {
                    success &&
                    <>
                      <span>{t("alerts.editor.ai.success.read")}</span>
                      <Check className="ml-1 color-success text-xl" />
                    </>
                  }
                  {
                    !success &&
                    <>
                  <span>
                    {t("alerts.editor.ai.success.error")}
                    <Close className="mx-1 color-error text-xl" style={{marginBottom:-5}} />
                    {t("alerts.editor.ai.success.error2")}
                  </span>
                    </>
                  }
                </Grid>
              ))
            }
          </Alert>
          : <Alert
              isOpen
              title={t("alerts.editor.ai.success.title")}
              acceptText={t("common.close")}
              onAccept={() => editorStore.setAiGenerationSuccessAlert(false)}
            />
          
      )
    }
  </>
})